<template>
  <v-dialog-loader width="500" :loading="!didLoad" :value="value" v-bind="$attrs" v-on="$listeners">
    <v-card>
      <v-btn class="float-right mt-3 mr-3" icon @click="$emit('input', false)"><v-icon v-html="mdiClose" /></v-btn>
      <v-card-title>Pack of {{n}} cards</v-card-title>
      <v-card-subtitle>These credits can be used for <b>personal cards</b>, <b>group cards</b>, or <b>invitations</b>. Premium effects not included.</v-card-subtitle>
      <v-card-subtitle v-if="global.profile && global.profile.org" class="warning--text font-weight-bold">Card credits will be applied to your organization</v-card-subtitle>
      <v-divider />
      <payment
        class="pa-6"
        :metadata="paymentMetadata"
        @complete="$emit('purchase'); $emit('input', false);"
        @loaded="didLoad = true"
      />
      <v-divider />
      <v-card-text class="pa-4 caption font-italic">
        Card credits will be saved to your account when purchased and automatically applied at checkout. You can always see the number of pre-paid / free card credits available in your account.
      </v-card-text>
    </v-card>
  </v-dialog-loader>
</template>


<script>
import Payment from '@/components/Payment.vue';
import VDialogLoader from '@/components/VDialogLoader.vue';
import { mdiClose } from '@mdi/js';


const CODE_N = {
  '5-PACK@3.99': 5,
  '50-PACK@2.99': 50
};


export default {
  name: 'buy-pack-dialog',

  components: {
    Payment,
    VDialogLoader
  },

  props: [ 'value', 'code' ],

  data() {
    return {
      didLoad: false
    };
  },

  computed: {
    n() {
      return CODE_N[this.code || '5-PACK@3.99'];
    },

    paymentMetadata() {
      return { target: 'BULK-PACK', code: this.code };
    }
  },

  created() {
    Object.assign(this, { mdiClose });
  }
}
</script>
